import { apiSlice } from "./apiSlice";
import { MESSAGE_ROOM_URL } from "../../constants/urls";

export const messageRoomApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUsersMessageRooms: builder.query({
            query: (id) => ({
                // Backend tüm odaları döndürmüyorsa pageSize artırın (API sözleşmesine göre)
                url: `${MESSAGE_ROOM_URL}/getUsersRooms/${id}?page=1&pageSize=500`,
                method: 'GET',
            })
        }),
        getMessageRoomById: builder.query({
            query: (id) => ({
                url: `${MESSAGE_ROOM_URL}/${id}`,
                method: "GET"
            })
        }),
        getMessageRoomPaginationById: builder.query({
            query: (data) => ({
                url: `${MESSAGE_ROOM_URL}/pagination/${data.id}${data.q ? `?${data.q}` : ""}`,
                method: 'GET'
            })
        }),
        getUnreadTotal: builder.query({
            // Backend aktif kullanıcıdan hesaplıyor; args burada sadece hook imzası için tutuluyor.
            query: () => ({
                url: `${MESSAGE_ROOM_URL}/unreadTotal`,
                method: 'GET'
            }),
            // Oda listesi unreadCounts ile aynı tag'de invalidate edilmesin — rozet titremesin diye ayrı.
            providesTags: ['MessageRoomUnreadTotal'],
        }),
        /** Oda bazlı okunmamış sayıları — backend: GET .../unreadCounts */
        getUnreadCountsByRoom: builder.query({
            query: () => ({
                url: `${MESSAGE_ROOM_URL}/unreadCounts`,
                method: 'GET',
            }),
            providesTags: ['MessageRoomUnread'],
        }),
        // File upload endpoint
        uploadMessageFile: builder.mutation({
            query: (data) => ({
                url: "/api/Message/FileUpload",
                method: "POST",
                body: data,
            }),
        }),
        // Add user to message room
        addUserToRoom: builder.mutation({
            query: (data) => ({
                url: `${MESSAGE_ROOM_URL}/AddUserToRoom`,
                method: "PUT",
                body: data,
            }),
        }),
        // Remove user from message room
        removeUserFromRoom: builder.mutation({
            query: (data) => ({
                url: `${MESSAGE_ROOM_URL}/RemoveUserFromRoom`,
                method: "PUT",
                body: data,
            }),
        }),
        // Create message room
        createMessageRoom: builder.mutation({
            query: (data) => ({
                url: MESSAGE_ROOM_URL,
                method: "POST",
                body: data,
            }),
        }),
        // Toggle lock status of message room (doctor only)
        toggleLockStatus: builder.mutation({
            query: (roomId) => ({
                url: `${MESSAGE_ROOM_URL}/toggleLock/${roomId}`,
                method: "PUT",
            }),
        }),
    })
})

export const {
    useGetUsersMessageRoomsQuery,
    useGetMessageRoomByIdQuery,
    useLazyGetMessageRoomByIdQuery,
    useLazyGetMessageRoomPaginationByIdQuery,
    useGetUnreadTotalQuery,
    useGetUnreadCountsByRoomQuery,
    useUploadMessageFileMutation,
    useAddUserToRoomMutation,
    useRemoveUserFromRoomMutation,
    useCreateMessageRoomMutation,
    useToggleLockStatusMutation
} = messageRoomApiSlice;